import React from "react";
import { FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage, setItemsPerPage }) => {
	const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

	return (
		<div className="flex flex-col items-center mt-4 space-y-4">
			<div className="flex justify-center items-center space-x-2">
				<label htmlFor="itemsPerPage" className="text-sm font-medium">
					Elementi per pagina:
				</label>
				<select
					id="itemsPerPage"
					className="border border-gray-300 rounded px-2 py-1 text-sm"
					value={itemsPerPage}
					onChange={(e) => setItemsPerPage(Number(e.target.value))}
				>
					<option value={10}>10</option>
					<option value={20}>20</option>
					<option value={50}>50</option>
					<option value={100}>100</option>
				</select>
			</div>
			<div className="flex justify-center items-center space-x-2">
				<button
					className="p-1 order rounded bg-blue-500 text-white disabled:opacity-50 flex items-center"
					disabled={currentPage === 1}
					onClick={() => onPageChange(1)}
				>
					<FaAngleDoubleLeft />
				</button>
				<button
					className="p-1 order rounded bg-blue-500 text-white disabled:opacity-50 flex items-center"
					disabled={currentPage === 1}
					onClick={() => onPageChange(currentPage - 1)}
				>
					<FaAngleLeft />
				</button>
				{pages.map((page) => (
					<button
						key={page}
						className={`px-3 py-1 border rounded ${
							page === currentPage ? "bg-blue-500 text-white" : "bg-gray-200"
						}`}
						onClick={() => onPageChange(page)}
					>
						{page}
					</button>
				))}
				<button
					className="p-1 border rounded bg-blue-500 text-white disabled:opacity-50 flex items-center"
					disabled={currentPage === totalPages}
					onClick={() => onPageChange(currentPage + 1)}
				>
					<FaAngleRight />
				</button>
				<button
					className="p-1 border rounded bg-blue-500 text-white disabled:opacity-50 flex items-center"
					disabled={currentPage === totalPages}
					onClick={() => onPageChange(totalPages)}
				>
					<FaAngleDoubleRight />
				</button>
			</div>
		</div>
	);
};

export default Pagination;
